import { useTheme } from "../theme.jsx";
import { I } from "./icons.jsx";

export default function Titlebar() {
  const { theme, setTheme } = useTheme();
  return (
    <header className="titlebar">
      <div className="tb-brand">
        <div className="traffic"><span/><span/><span/></div>
        <div className="lockup">Entry<em>Rate</em><span className="pip"/></div>
      </div>
      <div className="tb-mid">
        <div className="ws">
          <span className="dot"/>
          <span>Hivemind Bristol</span>
          <I.chev width="10" height="10"/>
        </div>
        <span className="live">All platforms syncing</span>
        <span style={{color:"var(--ink-4)"}}>v0.8.2 · build 311</span>
      </div>
      <div className="tb-right">
        <div className="theme-toggle" role="group" aria-label="Theme">
          <button onClick={()=>setTheme("dark")} className={theme==="dark"?"on":""} title="Dark"><I.moon/></button>
          <button onClick={()=>setTheme("light")} className={theme==="light"?"on":""} title="Light"><I.sun/></button>
        </div>
        <button className="icon-btn" title="Search"><I.search width="16" height="16" strokeWidth={1.6}/></button>
        <button className="icon-btn" title="Notifications"><I.bell width="16" height="16" strokeWidth={1.6}/></button>
        <button className="icon-btn" title="Help"><I.help width="16" height="16" strokeWidth={1.6}/></button>
        <div className="avatar">GB</div>
      </div>
    </header>
  );
}
